import {
  labelConfigSelector,
  updateLabelConfig,
} from '../../../data/labelInfos/index.js'
import ConfigSelect from './ConfigSelect.js'
import {SHIPPO} from '../../../common/constants/ShipperNames.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {
  ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
  defaultValidLabelPropertiesFunc,
} from './useLabelProperty.js'
import {getState, useSelector} from '../../../store.js'
import {dangerousGoodsTemplate} from './DangerousGoods.js'

const VALID_SHIPPER_TYPES = [SHIPPO]

function labelPropertiesFunc(shipperType, labelInfoID) {
  const {[dangerousGoodsTemplate(shipperType)]: dangerous_goods} =
    labelConfigSelector(getState(), {labelInfoID})

  return dangerous_goods && VALID_SHIPPER_TYPES.includes(shipperType)
    ? [`${shipperType}__dangerous_goods_code`]
    : []
}

export default function DangerousGoodsCode() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = DangerousGoodsCode.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )
  const {[dangerousGoodsTemplate(shipperType)]: dangerous_goods} = useSelector(
    (state) => labelConfigSelector(state, {labelInfoID}),
  )

  return (
    <ConfigSelect
      label="Dangerous Goods Code"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {
          [labelProperty]: value,
        })

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      shipperOptionsProperty="dangerous_goods_code"
      hide={!dangerous_goods}
    />
  )
}

DangerousGoodsCode.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc: labelPropertiesFunc,
    dependentPropertiesFunc: ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
